import type { UserProfile } from "../../../models/eplex/License";

/**
 * Собирает объект доп. информации о пользователе (`addInfo`) для виджета «Сигнал».
 *
 * Намеренно расширяемый: при появлении нового поля достаточно добавить его здесь,
 * без правок в подключении виджета. Включаются только заполненные поля —
 * пустые/`null` не передаём, чтобы не засорять данные на стороне Сигнала.
 */
export function buildSignalAddInfo(profile: UserProfile | null | undefined): Record<string, string> {
  const addInfo: Record<string, string> = {};

  const phone = profile?.phone;
  if (typeof phone === "string" && phone.trim() !== "") {
    addInfo.phone = phone;
  }

  const email = profile?.email;
  if (typeof email === "string" && email.trim() !== "") {
    addInfo.email = email;
  }

  return addInfo;
}
